import GmailConnectionControl from './GmailConnectionControl';

const PersonalConnections = () => {
  return <GmailConnectionControl />;
};

export default PersonalConnections;
